import _ from 'lodash'
// import { composeWithDevTools } from 'redux-devtools-extension'
import { doProcessRules } from '../../../lib/processPortalRules'

export const startKanbanUpdate = (retState, payload) => {
  const { pageUID, uid } = payload
  retState = retState.setIn(['state', pageUID, `${uid}-KabanCardFieldsUpdateCompleted`], false)
  retState = retState.setIn(['state', pageUID, `${uid}-KabanCardFieldsUpdateSuccess`], '')
  retState = retState.setIn(['state', pageUID, `${uid}-KabanCardFieldsUpdateFailed`], '')

  retState = doProcessRules(
    retState,
    false,
    false,
    [],
    [
      [pageUID, `${uid}-KabanCardFieldsUpdateCompleted`],
      [pageUID, `${uid}-KabanCardFieldsUpdateSuccess`],
      [pageUID, `${uid}-KabanCardFieldsUpdateFailed`],
    ]
  )

  return retState
}

export const applyKanbanUpdate = (retState, payload) => {
  const { value, pageUID, uid, valueFTHash, fields, data } = payload
  retState = retState.setIn(['state', pageUID, `${uid}-KabanCardFieldsUpdateCompleted`], true)
  retState = retState.setIn(['state', pageUID, `${uid}-KabanCardFieldsUpdateSuccess`], data?.status ? true : false)
  retState = retState.setIn(
    ['state', pageUID, `${uid}-KabanCardFieldsUpdateFailed`],
    !data?.status === true ? true : false
  )

  retState = doProcessRules(
    retState,
    false,
    false,
    [],
    [
      [pageUID, `${uid}-KabanCardFieldsUpdateCompleted`],
      [pageUID, `${uid}-KabanCardFieldsUpdateSuccess`],
      [pageUID, `${uid}-KabanCardFieldsUpdateFailed`],
    ]
  )
  return retState
}
